export default {
    "superadmin": "Суперадмин",
    "admin": "Администратор",
    "staff": "Сотрудник",
    "private_person": "Частное лицо",
}